import { Box } from '@mui/material';
import { useCallback } from 'react';
import { NavBar } from '../appBars/navBar/navBar';
import { CompanyInfo } from 'orderme-api-integration-client';
import { useTranslation } from 'react-i18next';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { AboutUsRoute } from '../../routes/allRoutes';
import { HtmlViewerContainer } from '../../controls/html/htmlViewerContainer';
import { useInfoFeedData } from '../../hooks/useInfoFeedData';
import { InfoFeedClient } from '../../helpers/client';

export function AboutUs() {
  const getCompanyInfo = useCallback((client: InfoFeedClient) => client.getCompanyInfo(), []);
  const companyInfo = useInfoFeedData<CompanyInfo>(getCompanyInfo);
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <NavBar barTitle={t('info:aboutUs')} />
      <BreadcrumbsBar paths={[{ path: AboutUsRoute }]} />
      <HtmlViewerContainer content={companyInfo?.description} isLoading={!companyInfo} />
    </Box>
  );
}
